import {
  FILTER_DATA,
  FILTER_DISPLAY,
  FILTER_INPUT,
  FILTER_OUTPUT,
  FilterType,
} from "../../types/Filter.ts";

export const EMPTY_FILTER: FilterType = {
  _id: "",
  title: "",
  regex: "",
  display: FILTER_DISPLAY.PRIMARY,
  inputType: FILTER_INPUT.CUSTOM,
  outputType: FILTER_OUTPUT.SINGLE,
  description: "",
  dataType: FILTER_DATA.STRING,
  operations: ["$eq"],
  options: [],
  unit: "",
  required: false,
};
